<template>
  <div class="house-importer-finance-stage-actions-panel">
    <app-panel title="Действия">
      <div class="house-importer-finance-stage-actions-panel__content">

        <div class="house-importer-finance-stage-actions-panel__row">
          <app-button color="success" @click="askUser" :disabled="isUpdating">{{isUpdating ? 'Создаю очереди...' :
            'Обновить финансовую систему'}}
          </app-button>
        </div>


        <div class="house-importer-finance-stage-actions-panel__row">
          <div>
            <app-datepicker label="Месяц показа квитанции (предыдущий месяц)" format="MMMM yyyy" minimum-view="month" v-model="month"/>
            <app-button type="border" style="margin-top: 15px; width: 100%;" @click="askUserForInvoices" :disabled="isShowing">{{isShowing ? 'Показываю...' : 'Показать квитанции'}}</app-button>
          </div>
        </div>

      </div>
    </app-panel>
  </div>
</template>


<script>
  export default {
    name: "ActionsPanel",
    props: {
      importInfo: {}
    },
    data() {
      return {
        isUpdating: false,
        isShowing: false,
        month: new Date()
      }
    },
    methods: {
      askUser() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'success',
          title: 'Подтверждение',
          text: 'Обновить финансовую систему?',
          acceptText: 'Да',
          cancelText: 'Нет',
          accept: this.updateFinance
        });
      },
      async updateFinance() {
        this.isUpdating = true;
        try {
          let {data} = await this.$http.get('import/houses/refresh_debts', {params: {import_id: this.importInfo.id}});
          if (data === 'created_queues') {
            this.$emit('update-queue', true);
          } else {
            this.$vs.notify({color: 'danger', title: 'UNKNOWN ANSWER', text: data});
          }
          this.isUpdating = false;

        } catch (e) {
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
          this.isUpdating = false;
        }
      },
      askUserForInvoices(){
        this.$vs.dialog({
          type: 'confirm',
          color: 'success',
          title: 'Подтверждение',
          text: 'Показать квитанции на выбранный месяц?',
          acceptText: 'Да',
          cancelText: 'Нет',
          accept: this.showInvoices
        });
      },
      async showInvoices(){
        try{
          this.isShowing = true;
          let body = {
            import_id: this.importInfo.id,
            month: this.$options.filters.moment(this.month, 'YYYY-MM')
          };

          let {data} = await this.$http.post('import/houses/show_kv', body);

          if (data === 'done') {
            this.$emit('update-stage');
          } else {
            this.$vs.notify({color: 'danger', title: 'UNKNOWN ANSWER', text: data});
          }
          this.isShowing = false;
        }
        catch (e) {
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
          this.isShowing = false;
        }
      }
    },
    mounted() {
      this.month = this.$moment(new Date()).subtract(1, 'month').toDate();
    }
  }
</script>
<style lang="scss">
  .house-importer-finance-stage-actions-panel {
    &__content{
      display: flex;
      margin: 0 -7.5px;
      flex-wrap: wrap;
    }

    &__row {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0;
      padding: 7.5px;
      flex: 0 0 50%;
      min-width: 400px;
    }
  }
</style>